import { Eye } from 'lucide-react';
import { useMemo } from 'react';

import { useAuth } from '@/app/core/auth/application/hooks/useAuth';
import useTranslations from '@/lang/useTranslations';
import { readSessionClaims } from '@/platform/auth/sessionClaims';

/**
 * Staff opened this session on the customer's behalf (the JWT carries `impersonated_by`). Pinned above
 * every page so nobody forgets whose account they are acting in — every change made here is the
 * customer's.
 */
export const ImpersonationBanner = () => {
  const { token, user } = useAuth();
  const { translation: t } = useTranslations('global');
  const { impersonatedBy } = useMemo(() => readSessionClaims(token), [token]);

  if (!impersonatedBy) return null;

  return (
    <div
      role="status"
      className="flex items-center justify-center gap-2 bg-warning px-4 py-1.5 text-center text-xs font-medium text-warning-foreground"
    >
      <Eye className="size-3.5 shrink-0" aria-hidden />
      <span>{t('impersonation_banner', { email: user?.email ?? '' })}</span>
    </div>
  );
};
